export interface MaterialDto {
    name: string;
    size: string; // e.g., "5.8MB"
    type: string;
    url: string;
}

export class Material {
    name: string;
    size: string;
    type: string;
    url: string;

    constructor(data: MaterialDto) {
        this.name = data.name;
        this.size = data.size;
        this.type = data.type;
        this.url = data.url ?? '#';
    }
}
